export default "__VITE_ASSET__4523a312__"